import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import {
    Back,
    Counter,
    Filter,
    Info,
    PageTitle,
    Select,
    Tabs,
    Bons,
    Gold,
    Silver,
    Tooltip,
} from 'react-wot-bootstrap'


import MembersTable from '../MembersTable/MembersTable'
import MembersControlBlock from '../MembersControlBlock/MembersControlBlock'
import Inbox from '../Inbox/Inbox'

import CurrencyTooltip from 'containers/ClanPanel/components/CurrencyTooltip/CurrencyTooltip'

import {
    permissions,
    hasPermission,
    hasAnyPermission,
    getRank,
    roleNames,
} from 'utils/clan_management/roles'
import { treasuryPropTypes } from 'propTypes'

import {
    BLOCK_TYPES,
    NEED_PERMISSIONS_FOR_MEMBER_CONTROL_BLOCK,
} from 'utils/clan_management/constants'
import { BATTLE_TYPES, RANDOM_BATTLE_TYPES } from 'utils/clan_management/battles'
import { PERIOD_TYPES } from 'utils/clan_management/periods'

import {
    PERIODS_BY_BLOCK_TYPE,
    TABS_BLOCK_TYPES,
    COMMON_STATISTICS_BATTLE_TYPES,
    STATISTICS_BATTLE_TYPES,
    RANDOM_BATTLE_TYPES_FILTER_ITEMS,
} from './constants'

import {
    AboutIndicatorsClanModesTooltip,
    StatisticsOverallTooltip,
    Statistics28DaysTooltip,
    Statistics7DaysTooltip,
    Statistics1DayTooltip,
    StatisticsDisabledPeriodTooltip,
    SelectedMembersTooltip,
    ClearSelectedMembersTooltip,
    StatisticsRandomDefaultBattleTypeTooltip,
    StatisticsRandomEpicBattleTypeTooltip,
    LeavingClanTooltip,
} from './tooltips'

import { BattleTypeTooltip } from '../Statistics/tooltips'

import {
    BACK_TO_CLAN_INFO,
} from 'containers/Stronghold/constants'

import { MEMBERS_ONLINE_TOOLTIP } from 'containers/ClanPanel/constants'

import {
    PERIOD_FILTER_CAPTION,
    CAPTION_ABOUT_INDICATORS,
    STATISTICS_BATTLE_TYPE_SELECT_CAPTION,
    TITLE_STAFF,
    MEMBERS_ONLINE,
    TREASURY,
} from './translations'

import { KEY_CODES } from 'constants'

import styles from './ClanManagement.scss'


class ClanManagement extends React.Component {
    static propTypes = {
        currentMemberId: PropTypes.number.isRequired,
        canSeeTreasury: PropTypes.bool.isRequired,
        showClanQuestsCard: PropTypes.bool.isRequired,
        isError: PropTypes.bool.isRequired,
        isFetching: PropTypes.bool.isRequired,
        clanTransactionInProcessing: PropTypes.bool.isRequired,
        blockType: PropTypes.oneOf(Object.values(BLOCK_TYPES)).isRequired,
        statisticsType: PropTypes.oneOf(Object.values(BLOCK_TYPES)).isRequired,
        statistics: PropTypes.object.isRequired,
        blockState: PropTypes.shape({
            period: PropTypes.oneOf(Object.values(PERIOD_TYPES)).isRequired,
            battleType: PropTypes.oneOf(Object.values(BATTLE_TYPES)),
            randomBattleType: PropTypes.oneOf(Object.values(RANDOM_BATTLE_TYPES)),
        }).isRequired,
        clan: PropTypes.shape({
            applications_count: PropTypes.number,
            treasury: treasuryPropTypes,
        }).isRequired,
        members: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number.isRequired,
                name: PropTypes.string.isRequired,
                role: PropTypes.oneOf(roleNames).isRequired,
                daysInClan: PropTypes.number.isRequired,
                status: PropTypes.string,
                logoutAt: PropTypes.number,
            }).isRequired,
        ).isRequired,
        membersOnline: PropTypes.number,
        membersTotal: PropTypes.number,
        tableHeadersSorting: PropTypes.object.isRequired,
        membersOperation: PropTypes.shape({
            selectedIds: PropTypes.arrayOf(PropTypes.number).isRequired,
        }).isRequired,

        currentMemberRole: PropTypes.string,

        fetchData: PropTypes.func.isRequired,
        onToggleMemberTick: PropTypes.func.isRequired,
        onResetSelectedMembers: PropTypes.func.isRequired,
        onTableHeaderClick: PropTypes.func.isRequired,
        onTickAllMembers: PropTypes.func.isRequired,
        onBackClick: PropTypes.func.isRequired,
        onChangeBlockType: PropTypes.func.isRequired,
        onChangePeriod: PropTypes.func.isRequired,
        onChangeBattleType: PropTypes.func.isRequired,
        onChangeRandomBattleType: PropTypes.func.isRequired,
        openInvitesApplicationsWindow: PropTypes.func.isRequired,

        requestMembersStatus: PropTypes.func.isRequired,
        showChangeCommanderDialog: PropTypes.func.isRequired,
        showRemoveMembersDialog: PropTypes.func.isRequired,
        showAllocatingResourcesDialog: PropTypes.func.isRequired,
        showChangeRoleDialog: PropTypes.func.isRequired,

        isGlobalMapEnabled: PropTypes.bool,
        isCNRealm: PropTypes.bool,
    }

    constructor(props) {
        super(props)

        this.state = {
            heightAfterTable: 0,
        }

        this.onKeyDown = this.onKeyDown.bind(this)
        this.onActionBarRef = this.onActionBarRef.bind(this)
        this.onMemberContextMenuItemSelected = this.onMemberContextMenuItemSelected.bind(this)
        this.onRemoveMembersClick = this.onRemoveMembersClick.bind(this)
        this.onAllocateTreasuryClick = this.onAllocateTreasuryClick.bind(this)
        this.onChangeRoleClick = this.onChangeRoleClick.bind(this)
        this.onChangeBlockType = this.onChangeBlockType.bind(this)
        this.onChangePeriod = this.onChangePeriod.bind(this)
        this.onChangeBattleType = this.onChangeBattleType.bind(this)
        this.onChangeRandomBattleType = this.onChangeRandomBattleType.bind(this)
    }

    componentDidMount() {
        this.props.fetchData(true)
        window.addEventListener('keydown', this.onKeyDown)

        this.props.requestMembersStatus()
        this.requestMembersTimeout = setInterval(this.props.requestMembersStatus, 3000)
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.onKeyDown)
        clearInterval(this.requestMembersTimeout)
    }

    onKeyDown(e) {
        if (e.keyCode === KEY_CODES.ESCAPE)
            this.props.onBackClick()
    }

    onActionBarRef(actionBar) {
        if (actionBar) {
            const offsetHeight = actionBar.offsetHeight
            if (offsetHeight !== this.state.heightAfterTable) {
                this.setState({ heightAfterTable: offsetHeight })
            }
        }
    }

    onMemberContextMenuItemSelected({ member, action }) {
        switch (action) {
        case 'CHANGE_COMMANDER':
            this.props.showChangeCommanderDialog(member)
            break
        case 'REMOVE_MEMBER':
            this.props.showRemoveMembersDialog([member], member.id)
            break
        case 'DIVIDE_PROFITS':
            this.props.showAllocatingResourcesDialog(member)
            break
        case 'CHANGE_ROLE':
            this.props.showChangeRoleDialog(member)
            break
        }
    }

    onChangeBlockType(blockType) {
        this.props.onChangeBlockType(this.props.clanTransactionInProcessing, blockType)
    }

    onChangePeriod(period) {
        this.props.onChangePeriod(this.props.clanTransactionInProcessing, period)
    }

    onChangeBattleType(battleType) {
        this.props.onChangeBattleType(this.props.clanTransactionInProcessing, battleType)
    }

    onChangeRandomBattleType(randomBattleType) {
        this.props.onChangeRandomBattleType(this.props.clanTransactionInProcessing, randomBattleType)
    }

    onRemoveMembersClick() {
        if (!hasPermission(this.props.currentMemberRole, permissions.REMOVE_MEMBER)) return

        const selectedMembers = this.props.members.filter((member) =>
            this.props.membersOperation.selectedIds.includes(member.id)
        )
        this.props.showRemoveMembersDialog(selectedMembers)
    }

    onAllocateTreasuryClick() {
        if (!hasPermission(this.props.currentMemberRole, permissions.DIVIDE_PROFITS)) return

        this.props.showAllocatingResourcesDialog()
    }

    onChangeRoleClick() {
        if (!hasPermission(this.props.currentMemberRole, permissions.CHANGE_ROLE)) return

        this.props.showChangeRoleDialog()
    }

    renderPeriodsFilter() {
        const blockType = this.props.blockType
        const blockState = this.props.blockState
        const battleType = blockState.battleType
        const randomBattleType = blockState.randomBattleType
        const period = blockState.period
        let items = PERIODS_BY_BLOCK_TYPE[blockType]
        const isBattleTypeOnlyWithAll = (
            battleType === BATTLE_TYPES.RANKED ||
            (battleType === BATTLE_TYPES.RANDOM && randomBattleType === RANDOM_BATTLE_TYPES.EPIC)
        )
        if (blockType === BLOCK_TYPES.STATISTICS && isBattleTypeOnlyWithAll) {
            items = items.map((item) => {
                const isDisabled = (item.value !== PERIOD_TYPES.ALL)
                return {
                    ...item,
                    isDisabled,
                    tooltipId: isDisabled ? StatisticsDisabledPeriodTooltip.id : item.tooltipId,
                }
            })
        }

        return (
            <div className={styles.filterItem}>
                <Filter
                    caption={PERIOD_FILTER_CAPTION}
                    items={items}
                    checkedItem={period}
                    onItemChange={this.onChangePeriod}
                />
            </div>
        )
    }

    renderBattleTypeSelect() {
        if (this.props.blockType !== BLOCK_TYPES.STATISTICS) return null
        const items = this.props.isGlobalMapEnabled ?
            STATISTICS_BATTLE_TYPES :
            COMMON_STATISTICS_BATTLE_TYPES

        return (
            <div className={styles.filterItem}>
                <Select
                    width={170}
                    caption={STATISTICS_BATTLE_TYPE_SELECT_CAPTION}
                    items={items}
                    tooltipId={BattleTypeTooltip.id}
                    selectedItem={this.props.blockState.battleType}
                    onItemChange={this.onChangeBattleType}
                />
                <BattleTypeTooltip />
            </div>
        )
    }

    renderRandomTypesFilter() {
        if (
            this.props.blockType !== BLOCK_TYPES.STATISTICS ||
            this.props.blockState.battleType !== BATTLE_TYPES.RANDOM
        ) {
            return null
        }

        return (
            <div className={styles.filterItem}>
                <Filter
                    items={RANDOM_BATTLE_TYPES_FILTER_ITEMS}
                    checkedItem={this.props.blockState.randomBattleType}
                    onItemChange={this.onChangeRandomBattleType}
                />
                <StatisticsRandomDefaultBattleTypeTooltip />
                <StatisticsRandomEpicBattleTypeTooltip />
            </div>
        )
    }

    renderMembersControlBlock() {
        const currentMemberRole = this.props.currentMemberRole
        const hasPermissions = hasAnyPermission(currentMemberRole, NEED_PERMISSIONS_FOR_MEMBER_CONTROL_BLOCK)
        if (!currentMemberRole || !hasPermissions) return null

        const { members, membersOperation } = this.props

        let selectedMembers = members
        if (members.length !== membersOperation.selectedIds.length) {
            selectedMembers = members.filter(member => membersOperation.selectedIds.includes(member.id))
        }

        let counter = null
        if (selectedMembers.length > 0) {
            counter = (
                <div className={styles.counter} key="members-counter">
                    <Counter
                        total={members.length}
                        current={selectedMembers.length}
                        onClick={this.props.onResetSelectedMembers}
                        tooltipId={SelectedMembersTooltip.id}
                        buttonTooltipId={ClearSelectedMembersTooltip.id}
                    />
                    <SelectedMembersTooltip
                        count={selectedMembers.length}
                        total={members.length}
                    />
                    <ClearSelectedMembersTooltip/>
                </div>
            )
        }

        const currentMemberRank = getRank(this.props.currentMemberRole)
        const isSelectedMembersWithSameOrHighRole = selectedMembers.some(
            member => getRank(member.role) >= currentMemberRank
        )

        const classNamePanel = classNames(styles.panel, {
            [styles.isProcessing]: this.props.isFetching,
        })

        return (
            <div className={classNamePanel} ref={this.onActionBarRef}>
                {counter}
                <MembersControlBlock
                    currentMemberRole={currentMemberRole}
                    selectedMembersCount={selectedMembers.length}
                    isSelectedMembersWithSameOrHighRole={isSelectedMembersWithSameOrHighRole}
                    clanTreasure={this.props.clan.treasury}
                    onAllocateTreasuryClick={this.onAllocateTreasuryClick}
                    onChangeRoleClick={this.onChangeRoleClick}
                    onRemoveMembersClick={this.onRemoveMembersClick}
                />
            </div>
        )
    }

    renderAboutIndicator() {
        if (this.props.blockType !== BLOCK_TYPES.CLAN_MODES) return null

        return (
            <div
                className={styles.info}
                data-tip data-for={AboutIndicatorsClanModesTooltip.id}
            >
                <Info />
                {CAPTION_ABOUT_INDICATORS}
                <AboutIndicatorsClanModesTooltip />
            </div>
        )
    }

    renderMembersTable() {
        if (this.props.members.length === 0 && !this.props.isError) return null

        const membersControlBlock = this.props.isError ? null : this.renderMembersControlBlock()
        return (
            <div className={styles.wrapper}>
                <div className={styles.table}>
                    <MembersTable
                        currentMemberId={this.props.currentMemberId}
                        currentMemberRole={this.props.currentMemberRole}
                        members={this.props.members}
                        headersSorting={this.props.tableHeadersSorting}
                        isError={this.props.isError}
                        isProcessing={this.props.isFetching}
                        statisticsType={this.props.isError ? this.props.blockType : this.props.statisticsType}
                        statistics={this.props.statistics}
                        selectedMembersIds={this.props.membersOperation.selectedIds}
                        heightAfterTable={this.state.heightAfterTable}
                        onReloadClick={this.props.fetchData}
                        onToggleMemberTick={this.props.onToggleMemberTick}
                        onHeaderClick={this.props.onTableHeaderClick}
                        onTickAllMembers={this.props.onTickAllMembers}
                        onMemberContextMenuItemSelected={this.onMemberContextMenuItemSelected}
                        selectedPeriod={this.props.blockType === BLOCK_TYPES.CLAN_MODES ?
                            this.props.blockState.period : null
                        }
                        showClanQuestsCard={this.props.showClanQuestsCard}
                    />
                </div>
                <div className={styles.memberBlock}>
                    {membersControlBlock}
                </div>
            </div>
        )
    }

    renderInbox() {
        if (!hasPermission(this.props.currentMemberRole, permissions.HANDLE_INVITES)) return null

        return (
            <Inbox
                messages={this.props.clan.applications_count}
                onClick={this.props.openInvitesApplicationsWindow}
            />
        )
    }

    renderSubtitle = () => {
        let treasury
        if (this.props.canSeeTreasury) {
            treasury = (
                <span>
                    {TREASURY}
                    {this.props.clan.treasury.crystal !== undefined && (
                        <span
                            className={styles.treasuryCurrency}
                            data-tip data-for='clan_panel_currency_tooltip_crystal'
                        >
                            <Bons value={this.props.clan.treasury.crystal} iconPosition="before" />
                            <CurrencyTooltip amount={this.props.clan.treasury.crystal} type='crystal' />
                        </span>
                    )}
                    {this.props.clan.treasury.gold !== undefined && (
                        <span
                            className={styles.treasuryCurrency}
                            data-tip data-for='clan_panel_currency_tooltip_gold'
                        >
                            <Gold value={this.props.clan.treasury.gold} iconPosition="before" />
                            <CurrencyTooltip amount={this.props.clan.treasury.gold} type='gold' />
                        </span>
                    )}
                    {this.props.clan.treasury.credits !== undefined && (
                        <span
                            className={styles.treasuryCurrency}
                            data-tip data-for='clan_panel_currency_tooltip_credits'
                        >
                            <Silver value={this.props.clan.treasury.credits} iconPosition="before" />
                            <CurrencyTooltip amount={this.props.clan.treasury.credits} type='credits' />
                        </span>
                    )}
                </span>
            )
        }

        return (
            <div className={styles.subtitle}>
                <span
                    className={styles.membersOnline}
                    data-tip data-for='members_online'
                >
                    {MEMBERS_ONLINE(this.props.membersOnline, this.props.membersTotal)}
                    <Tooltip id='members_online'>
                        {MEMBERS_ONLINE_TOOLTIP(this.props.membersOnline, this.props.membersTotal)}
                    </Tooltip>
                </span>
                {treasury}
            </div>
        )
    }

    render() {
        const baseClassNames = classNames(
            styles.base,
            {
                [styles.base__cn]: this.props.isCNRealm,
            }
        )

        return (
            <div className={baseClassNames}>
                <div className={styles.header}>
                    <div className={styles.headerInner}>
                        <div className={styles.back}>
                            <Back
                                caption={BACK_TO_CLAN_INFO}
                                side="left"
                                type="back"
                                onClick={this.props.onBackClick}
                            />
                        </div>
                        <div className={styles.title}>
                            <PageTitle>{TITLE_STAFF}</PageTitle>
                            {this.renderSubtitle()}
                        </div>
                        <div className={styles.tabs}>
                            <Tabs
                                items={TABS_BLOCK_TYPES}
                                checkedItem={this.props.blockType}
                                onItemChange={this.onChangeBlockType}
                            />
                        </div>
                        <div className={styles.filter}>
                            {this.renderPeriodsFilter()}
                            {this.renderBattleTypeSelect()}
                            {this.renderRandomTypesFilter()}
                            {this.renderAboutIndicator()}

                            <StatisticsOverallTooltip />
                            <Statistics28DaysTooltip />
                            <Statistics7DaysTooltip />
                            <Statistics1DayTooltip />
                            <StatisticsDisabledPeriodTooltip />
                            <LeavingClanTooltip />
                        </div>
                        {this.renderInbox()}
                    </div>
                </div>
                {this.renderMembersTable()}
            </div>
        )
    }
}

export default ClanManagement



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/ClanManagement/ClanManagement.js